"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateUserProfileRequestSchema = exports.UserUsageStatsSchema = exports.UserPreferencesSchema = exports.UserProfileSchema = exports.CommunityLevelSchema = exports.SubscriptionTierSchema = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
const auth_1 = require("./auth");
// Subscription Tiers
exports.SubscriptionTierSchema = zod_1.z.enum([
    'free',
    'basic',
    'premium',
    'professional'
]);
// Community Levels
exports.CommunityLevelSchema = zod_1.z.enum([
    'curious_observer',
    'active_questioner',
    'discerning_mind',
    'truth_seeker',
    'wisdom_guide'
]);
// User Profile
exports.UserProfileSchema = zod_1.z.object({
    id: common_1.UUIDSchema,
    email: zod_1.z.string().email(),
    name: zod_1.z.string().optional(),
    profilePicture: zod_1.z.string().url().optional(),
    provider: auth_1.AuthProviderSchema,
    providerId: zod_1.z.string(),
    subscriptionTier: exports.SubscriptionTierSchema,
    monthlyChecksUsed: zod_1.z.number().min(0),
    monthlyChecksResetAt: common_1.DateSchema.optional(),
    // Legacy field - kept for backward compatibility during migration
    trialChecksUsed: zod_1.z.number().min(0).max(10).optional(),
    communityLevel: exports.CommunityLevelSchema,
    reputationScore: zod_1.z.number().min(0),
    createdAt: common_1.DateSchema,
    updatedAt: common_1.DateSchema,
});
// User Preferences
// Note: After settings audit (Jan 2026), only emailNotifications is functional
// All other settings were removed as they were never implemented
exports.UserPreferencesSchema = zod_1.z.object({
    emailNotifications: zod_1.z.boolean().default(true),
});
// User Usage Statistics
exports.UserUsageStatsSchema = zod_1.z.object({
    totalFactChecks: zod_1.z.number(),
    dailyFactChecks: zod_1.z.number(),
    monthlyFactChecks: zod_1.z.number(),
    accuracyRate: zod_1.z.number().min(0).max(100),
    communityContributions: zod_1.z.number(),
    badgesEarned: zod_1.z.number(),
    currentStreak: zod_1.z.number(),
    longestStreak: zod_1.z.number(),
    // UI specific aliases/fields
    verificationsCount: zod_1.z.number().optional(),
    trustScore: zod_1.z.number().optional(),
    contributionsCount: zod_1.z.number().optional(),
    followersCount: zod_1.z.number().optional(),
});
// Update User Profile Request
exports.UpdateUserProfileRequestSchema = zod_1.z.object({
    preferences: exports.UserPreferencesSchema.partial().optional(),
    communitySettings: zod_1.z.object({
        displayName: zod_1.z.string().max(50).optional(),
        bio: zod_1.z.string().max(500).optional(),
        interests: zod_1.z.array(zod_1.z.string()).max(10).optional(),
    }).optional(),
});
//# sourceMappingURL=user.js.map